import { createContext } from 'react';
export default createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setRefTarget: () => { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setRefContent: () => { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setRefArrow: () => { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOpen: () => { },
    refArrow: null,
    refTarget: null,
    refContent: null,
    styles: {},
    attributes: {},
    triggers: ['click'],
    targetClassName: '',
    hasArrow: true,
    isOpen: false,
});
